import patentDeleteInput from './saveInputs/patentDeleteInput';

export default (patent) => {
  console.log(
    '[DeletePatentMutation] Building GraphQL mutation for patent:',
    patent,
  );
  console.log('[DeletePatentMutation] Patent ID:', patent?.id);

  const mutation = `
    deletePatentLostHistory (history: {
        ${patentDeleteInput(patent)}
    })
`;

  console.log('[DeletePatentMutation] Generated GraphQL mutation:', mutation);
  return mutation;
};
